import { getAllValues } from '@/helpers';

const userBasePath = '/user';
const myScheduleBasePath = '/my-schedule';
const myAvailabilityBasePath = '/my-availability';
const timeOffBasePath = '/time-off';
const memberBasePath = '/member';
const adminBasePath = '/admin';
const gigCompliance = '/gig-compliance';
const myGigs = '/my-gigs';
const resourcesBasePath = '/resources';

const routes = {
  backendUrl: {
    apiConfiguration: {
      apiSsoConfigurationEndpoint: '/config/clientconfig',
    },
    gigApplication: {
      create: 'api/v3/member/gig/create',
      get: 'api/v3/member/gig/get',
      createApplication: '/member/application/g/create',
      saveStepStatus: '/member/applicationstep/g/save',
      getStepStatus: '/member/applicationstep/g/list/application',
      saveApplicationFlags: '/member/application/g/save',
      getApplicationFlags: '/member/application/g',
      createNavigationHistory: '/member/gig/navigation/history',
      editApplication: '/member/application/edit',
      deleteApplication: '/member/application/delete',
    },
    referralProgram: {
      canShowReferralModal: '/referralprogram/get/referralmodalconfig',
      canShowReferralMenu: '/referralprogram/get/canshowreferralmenu',
      updateReferralModalLastShown: 'referralprogram/set/modallastshown',
      getRefferedPeopleList: '/referralprogram/get/referredpeoplelist',
      getReferralMainPageData: '/referralprogram/get/mainpagedata',
      updatereferralprogramterms: 'referralprogram/set/termsconditions/',
      getActiveGigsList: 'referralprogram/get/activeGigs/forReferrals',
      getReferralLinkGig: 'referralprogram/get/referrallink',
      updatereferralpaymentAlert: 'referralprogram/set/PayShark/paymentAlert/',
      sendInvitationEmail: 'referralprogram/send/referralemail',
      sendInvitationSms: 'referralprogram/send/textmessage',
    },
    esign: {
      userdocumentList: '/esign/user/{userId}/documents',
      getEsignAgreementBase64: '/esign/agreements/{id}/base64',
      getDocumentEsignUrl: '/esign/user/documents/{id}/signurl',
      getUnsignedEsignDocumentsCount: '/esign/user/{userId}/unsignedDocumentsCount',
      updateDocumentSignedOn: '/esign/user/document/signedOn',
    },
    courseDetails: {
      list: 'course/class/list/application',
      makePayment: `${memberBasePath}/course/payment`,
      rescheduleList: 'course/reschedule/class/list',
    },
    courseClass: {
      getClass: `${memberBasePath}/course/class`,
      saveClass: `${memberBasePath}/course/class/save`,
    },
    getContactDetails: '/pub/lxuser',
    setContactDetails: '/agent/profile/update',
    member: {
      profilePhoto: {
        save: '/member/profilepicture',
      },
    },
    getTimeZoneNames: '/pub/user/tzinfo/gettimezones',
    hardware: {
      getList: `${memberBasePath}/hardwaretest/g/list/user`,
      getDetails: `${memberBasePath}/hardwaretest`,
      getToken: `${memberBasePath}/hardwaretest/token`,
    },
    equipment: {
      getEquipments: `${memberBasePath}/gigequipment/g/list/gig`,
      getEquipmentAnswersUser: `${memberBasePath}/userequipment/g/list/user?d=true&c=equipmentAnswerId%7CequipmentId`,
      getEquipmentAnswersList: `/pub/vocabequipmentanswer/list`,
      setEquipmentAnswers: `${memberBasePath}/userequipment/save`,
    },
    gigs: {
      getLiveCampaignList: `${memberBasePath}/campaigns/2`,
      getLiveCampaignDetail: `${memberBasePath}/campaign`,
      getFutureCampaign: `${memberBasePath}/campaign/list/3?d=true`,
      getContractRequirement: `/sp/requirement/primary/gig`,
      getAppliedgigs: `${memberBasePath}/gigs/applied`,
    },
    voice: {
      getVoiceQuestion: `${memberBasePath}/gigvoicequestion/g/list/gig`,
      getVoiceAnswer: `${memberBasePath}/voiceanswer/list/application`,
    },
    gigAdmin: {
      get: `${memberBasePath}/gig/list`,
      getById: `${memberBasePath}/gig/`,
      create: `${memberBasePath}/gig/create`,
      update: `${memberBasePath}/gig/g/update`,
      delete: `${memberBasePath}/gig/g/delete`,
      getHardwareRequirements: `${adminBasePath}/gig/{gigId}/hardwarerequirements`,
      getLanguages: `${memberBasePath}/gig/{gigId}/language`,
      getCountries: `${adminBasePath}/gig/{gigId}/countryprovince/list`,
      country: {
        get: `${memberBasePath}/gigCountry/`,
      },
      province: {
        get: `${memberBasePath}/gigcountryprovince/g/list/gig/`,
      },
      networkProfileByClientId: {
        get: `${memberBasePath}/networkprofile/list/client/`,
      },
      preview: `${adminBasePath}/gig/`,
      section: {
        gigDetails: `${memberBasePath}/gig/save`,
        gigHardwareRequirements: `${adminBasePath}/gig/{gigId}/hardwarerequirements/save`,
        gigLanguage: `${adminBasePath}/gig/{gigId}/languages/save`,
        gigCountries: `${adminBasePath}/gig/{gigId}/location/save`,
      },
    },
    interviewQuestions: {
      interviewQuestionList: `SU/interview/question/list`,
      arrangeQuestionOrder: `SU/interview/question/gig/arrange`,
      categoriesList: `/pub/vocab/interview/question/category/list`,
      allClientInterviewQuestionsList: `SU/interview/question/client/list/`,
      saveInterviewQuestion: `SU/interview/question/save`,
    },
    voiceQuestions: {
      voiceQuestionList: `SU/voice/question/list`,
      arrangeVoiceQuestionOrder: `SU/voice/questions/gig/arrange`,
      categoriesList: `/pub/voice/question/category/list`,
      assignedVoiceQuestionOrder: `SU/voice/questions/gig/assign`,
      allVoiceQuestionList: `SU/voice/question/client/list`,
      removeVoiceQuestionList: `SU/voice/questions/gig/delete`,
      saveVoiceQuestion: `SU/voice/question/save`,
    },
    client: {
      get: '/pub/client/list',
      getById: '/pub/client/',
      getClassTrainers: 'pub/client/{clientId}/trainers/list',
    },
    campaigns: {
      getByClientId: '/member/gig/list?Client=',
      getCampaignStats: '/member/campaign/stats/',
    },
    earnings: {
      getMyEarningsById: 'SU/mas/campaign/earning/',
    },
    interviews: {
      getSlotsByDate: 'SU/interview/timeslots',
      saveInterviewSlots: 'SU/interview/timeslots/save',
      copyInterviewSlots: 'SU/interview/timeslots/copy',
      getInterviewNotes: 'SU/interview',
      getInterviewSummary: 'SU/interview/{interviewId}/summary',
      getShowInterviewDetails: 'SU/interview/{interviewId}/showDetails',
      getSlotsByCampaignAndDate: 'SP/interview/list/campaign',
      saveInterviewSlotSelection: 'SP/interview/selection/set',
    },
    upcomingInterviews: {
      interviewList: '/SU/interview/list/campaign',
      interviewerList: '/SU/interview/campaign',
      cancelInterview: '/SU/interview/cancel',
      rescheduleInterview: '/SU/interview/reschedule',
      rescheduleInterviewSP: '/SP/interview/reschedule',
      interviewDetail: '/SU/interview/detail',
      interviewAttendance: '/pub/vocabinterviewattendance/g/list',
      saveInterviewScore: '/SU/interviewscore/save',
      addInterviewNote: '/SU/interview/notes',
    },
    application: {
      context: `${memberBasePath}/application/`,
      getApplications: `/SU${memberBasePath}/application/list`,
      getApplicationStatusCountByCampaignId: `/SU${memberBasePath}/application/statuslist/count/campaign/`,
      getApplicationDetailsStatusCountByCampaignId: `${memberBasePath}/application/g/list/campaign/`,
      getApplicationDetailsByApplicationId: `/SU${memberBasePath}/application/detail/`,
      getCommunicationLogList: `${memberBasePath}/communication/log`,
      getCommunicationTypeList: `/pub/vocabCommunicationType/list`,
      getCommunicationStatusList: `${memberBasePath}/communicationTypeStatus/list`,
      saveCommunicationLog: `${memberBasePath}/communication/log/save`,
      setApplicationStatusByStatusId: `/SU${memberBasePath}/application/status/set/`,
      getApplicationNotesByUserId: `/SU${userBasePath}/note/list/`,
      saveApplicationNote: `/SU${userBasePath}/note/save`,
      deleteApplicationNote: `/SU${userBasePath}/note/delete`,
      deleteCommunicationLog: `${memberBasePath}/communication/log/delete`,
      agentGigCompliance: `su/gig/compliancestats`,
      getMasUsers: `/SU/mas/users/list/campaign/`,
      getClasses: `/member/class/list/`,
      getApplicationStatusValidation: `member/application/get/application/status/validation/`,
    },
    gigCampaignAdmin: {
      create: `${memberBasePath}/campaign/save`,
      update: `${memberBasePath}/campaign/update`,
      getCampaignById: `${memberBasePath}/campaign/`,
      getLatestCampaignByGigId: `${memberBasePath}/campaign/gig/`,
      getCampaignCountryProfileList: `${memberBasePath}/campaign/ratio/profile`,
    },
    courseBuilder: {
      getCourseByClient: `${memberBasePath}/course/list/client/`,
      getCourseById: `admin/course/`,
      create: `admin/course/create`,
    },
    classBuilder: {
      getFilters: `/classbuilder/filters`,
      getFiltersForGig: `/classbuilder/gig/{gigId}/filters`,
      getAllClasses: `/classbuilder/classes`,
      saveClass: `/member/course/class/save`,
      getClassAndSessionDetails: 'member/class/details/{classId}',
      getClassAttendanceDetails: 'member/class/attendance/{classId}',
      getClassUserCount: 'member/course/class/{classId}/classUserCount',
      getClassCountryApplicants: 'member/course/class/{classId}/countryApplicants',
      deleteClass: 'member/course/class/{classId}/delete',
    },
    classRoster: {
      getClassAttendanceList: 'SU/member/campaign/classes/attendance',
      getClassSessionsList: 'SU/member/campaign/classSessions',
      getClassRosterList: 'SU/member/campaign/users/classes',
      getClassAttendanceListByApplication: 'SU/member/campaign/classes/attendance/application',
    },
    classes: {
      getClassesStats: '/member/class/stats/',
      getClassSummaryList: 'SU/class/user/sessions?ClassId=#ClassId&IsRemoved=0',
      getClassRemovedList: 'SU/class/user/sessions?ClassId=#ClassId&IsRemoved=1',
      getClassDetails: '/member/class/details/',
      getClassUserStatusList: '/pub/vocab/classuserstatus/list',
      setAttendance: 'SU/member/class/user/attendances',
      setSummaryComments: '/SU/classuser/set/comment',
      setSummaryStatus: 'SU/classuser/set/status',
      getCampaignClassList: 'SU/member/campaign/classes',
      setSummaryClassUser: 'SU/classuser/summary/set/',
      getTrainingList: 'SU/class/user/list?ClassId=#ClassId&IsRemoved=0',
      setTrainingList: 'SU/class/user/training/setup/update',
      setRemoveStatus: 'SU/classuser/status/set/',
      registerRescheduleClass: 'SP/classuser/reschedule/save',
      removeFromClassInitiatedBySP: 'SP/classuser/remove/class',
      markAttendanceClass: 'SP/member/class/user/mark-attendance',
    },
    permissionAdmin: {
      permission: 'admin/permission',
      permissionList: 'admin/permission/list',
      permissionLevelList: 'admin/permissionLevel/list',
      getGigPermissionList: 'admin/permission/client',
      getGigPermissionGroupList: 'admin/permission/group/client',
      getPermissionClientList: 'admin/permissionClient',
      setGigPermissionAndGroup: 'admin/permission/client',
      getUserListByTypes: 'admin/user/bytypes',
      getUserPermissionList: 'admin/permission/client',
      getUserPermissionGroupList: 'admin/permission/group/client',
      setUserPermissionAndGroup: 'admin/permission/client',
      getRosterUserPermissionList: 'admin/permission/client',
      getPermissionGroup: 'admin/permission/group',
      groupPermission: 'admin/group/permission',
    },
    adminImpersonation: {
      getUsersWithImpersonationPermission: 'auth/get/impersonatepermissions',
      impersonateUser: 'auth/impersonate',
    },
    agent: {
      serviceProviders: 'admin/serviceprovider',
      getServiceProviders: 'admin/serviceprovider/list',
      getServiceProviderDetails: 'admin/serviceprovider/profiledetails',
      getServiceProviderGigsDetails: 'admin/serviceprovider/gigs',
      getServiceProviderApplicationHistoryDetails: 'admin/serviceprovider/ApplicationHistory',
      getVoiceQuestionAnswerList: '/member/voicequestionanswer/list/application',
      createAgent: 'admin/serviceprovider/create/account',
      updateAgent: 'admin/serviceprovider/create/account',
      getServiceProviderCredDetails: 'admin/serviceprovider/activecredentials',
      getServiceProviderTPCredDetails: 'admin/serviceprovider/tpcredentials',
      getAgentSpeedTest: 'admin/serviceprovider/speedtest/list',
      getAgentSpeedTestDetail: 'member/profile/speedtest/detail',
      getAgentHardwareTest: 'admin/serviceprovider/hardwaretest/list',
      getServiceProviderSupplierList: 'admin/serviceprovider/supplier/list',
      createCredential: 'admin/serviceprovider/create/credential',
      getCredentialList: 'admin/serviceprovider/credentials/list',
      getSWSReasonList: 'admin/serviceprovider/swsorder/reason',
      getSWSVersionList: 'admin/serviceprovider/swsorder/version',
      getSWSStatusList: 'admin/serviceprovider/swsorder/status',
      createSWSOrder: 'admin/serviceprovider/swsorder/create',
      getSWSOrderDetails: 'admin/serviceprovider/swsorder/list',
      setAgentCredential: 'admin/serviceprovider/setcredentials',
      updateAgentCredential: 'admin/serviceprovider/credentials/ActivateOrExpire',
      updateSWSDetails: 'admin/serviceprovider/swsorder/set',
      getServiceProviderGigPhaseList: 'admin/serviceprovider/gigphase/vocab',
      updateGigPhase: 'admin/serviceprovider/gigs/updategigphase',
      getResetPasswordLink: 'pub/userProfile/reset/admin/generate',
      getESignDocuments: 'esign/document/list',
      getESignVersions: 'esign/document/version/list/',
      getESignDocumentConfig: 'esign/config',
      getGigCountries: 'member/gigCountry/',
      getTemplateList: 'esign/templates',
      getESignDocument: 'esign/document',
      getESignDocumentContent: 'esign/templates',
      createMSADocument: 'esign/document/msa/create',
      updateMSADocument: 'esign/document/msa/update',
      createSOWDocument: 'esign/document/sow/create',
      updateSOWDocument: 'esign/document/sow/update',
      getDulpicateList: 'member/fraudCheck/user',
      getFraudGroupUser: 'member/FraudCheck/group',
      updateExistingGroup: '/FraudCheckUserGroup',
      createNewGroup: '/FraudCheckGroup ',
      getMobileVerificationTypes: '/sms/getmobileverificationtypes ',
      getMobileVerificationTypesByCountry: '/sms/getmobileverificationtypesbycountry',
      getBGCheckUserData: 'admin/serviceprovider/backgroundcheck',
      getBGCheckOptions: '/pub/vocabbackgroundcheckstatus/list',
    },
    fraudGrp: {
      getFraudcheckgroup: '/FraudCheckGroup',
      updateFraudGroup: '/FraudCheckGroup',
      deleteUser: '/FraudCheckUserGroup',
      usersList: '/FraudCheckUserGroup/{fraudCheckGroupId}/users',
      fraudGroupList: '/member/fraudgroup/get',
      getSessionLogsList: '/admin/serviceprovider/sessionlog',
    },
    notify: {
      getNotifyJobList: '/su/notify/job/list/client/',
      getNotifyQueueList: '/su/notify/queue/list/job/',
      getSchudulelistWithClientId: '/su/schedule/list?clientId=',
      getNotifyJobCreate: '/su/notify/job/create',
      setNotifyPreview: '/su/notify/preview',
    },
    courseBuilderTraining: {
      create: 'admin/course/training/create',
    },
    vocab: {
      getCountry: '/pub/vocabcountry/g',
      getCountryList: '/pub/vocabcountry/g/list',
      getProvinceList: '/pub/vocabprovince/g/list',
      getProvinceListByCountryId: '/pub/vocabprovince/g/list/vocabcountry/',
      getLanguageList: '/pub/vocablanguage/g/list',
      getLanguageProficiencyList: '/pub/vocablanguageproficiency/g/list',
      getLanguageProficiencyAreaList: '/pub/vocablanguageproficiencyarea/g/list',
      getHardwareRequirementList: '/pub/vocabhardwarerequirement/g/list',
      getHardwareRequirementOptionList: '/pub/vocabhardwarerequirementoption/g/list',
      getCurrencyList: '/pub/vocabCurrency/g/list',
      getTypesList: '/pub/vocabgigtype/g/list',
      getTypeById: `/pub/vocabgigtype/g`,
      getLengthList: '/pub/vocabgiglength/g/list',
      getLengthById: '/pub/vocabgiglength/g/',
      getCampaignStatusList: '/pub/vocabcampaignstatus/g/list',
      getCourseDurationTypeList: '/pub/vocabcoursedurationtype/g/list',
      getCourseClassStatusList: '/pub/vocabclassstatus/list',
      getCourseClassTypeList: '/pub/vocabclasstype/list',
      getCourseClassPlaatformList: '/pub/vocabclassplatform/list',
      getGigPriorityList: '/pub/vocabgigpriority/list',
      getVocabRatioTypeList: '/pub/vocabratiotype/list',
      getVocabRatioProfileList: '/pub/vocabratioprofile/list',
    },
    featureFlags: {
      getFeatureFlags: 'featureflags/get',
    },
    agentPosition: {
      getByClientId: '/pub/agentposition/g/list/client/',
      getByClientIdAndCountryIds: '/pub/agentposition/',
    },
    userProfile: {
      setCurrentClient: 'pub/userProfile/setCurrentClient?clientId=',
      setMenuType: 'pub/userprofile/setmenutype/',
      sendResetPasswordLink: 'pub/userProfile/reset/generate/',
      verifyResetLink: 'pub/userProfile/reset/verify/',
      resetPassword: 'pub/userProfile/reset/setpass',
      getUpdatedProfile: 'pub/userProfile/get/updatedProfile',
      login: 'auth/login',
      getProfile: 'auth/getprofile',
      checkUserIdentity: 'auth/getuser',
      logout: 'auth/logout',
    },
    referAFriend: {
      payRates: 'referfriend/payrates',
      getGigList: 'referfriend/gig/list',
      createFeaturedGig: 'referfriend/featuredgig/create',
      deleteFeaturedGig: 'referfriend/featuredgig/delete',
    },
    community: {
      getConfiguration: 'admin/community/config',
      getBlogs: 'admin/community/blog/list',
      getFaqs: 'admin/community/faq/list',
      getTestimonials: 'admin/community/testimonials/list',
      saveBlog: 'admin/community/blog/save',
      saveFaq: 'admin/community/faq/save',
      saveTestimonial: 'admin/community/testimonial/save',
      getBlogById: 'admin/community/blog/',
      getFaqById: 'admin/community/faq/',
      getTestimonialById: 'admin/community/testimonial/',
      archiveCommunity: 'admin/community/{id}/archive',
      unarchiveCommunity: 'admin/community/{id}/unarchive',
      reorderCommunity: 'admin/community/reorder',
      getCountriesListByClientId: 'member/gigCountry/list/client/',
      getCommunityPageBlogs: 'sp/community/blogs',
      getCommunityFAQ: 'sp/community/FAQ',
      getCommunityStatistics: 'sp/community/statistics',
      saveCommunityView: 'sp/community/saveview',
      hasActiveGigs: 'sp/community/hasactivegigs',
      getTestomonials: 'sp/community/testimonials',
    },
    communication: {
      sp: {
        getMailBox: 'sp/communications/mailbox/',
        getServicePass: 'sp/communications/servicepass/',
        getManageEngineLoginUrl: 'sp/communications/manageengineloginurl',
        getRedirect: 'sp/communications/redirect/',
        getSharedMailBox: 'sp/communications/sharedmailbox/',
        getChatUrl: 'sp/communications/chat_url',
      },
      su: {
        getMailBox: 'su/communications/mailbox/',
        getServicePass: 'su/communications/servicepass/',
        getRedirect: 'su/communications/redirect/',
        getSharedMailBox: 'su/communications/sharedmailbox/',
        getChatUrl: 'su/communications/chat_url/',
      },
    },
    gigUser: {
      liveStats: 'SU/member/live/stats/campaign/',
      inactiveStats: 'SU/member/inactive/stats/campaign/',
    },
    mas: {
      getMasUsers: 'SU/member/mas/get/masusers/',
      changeMasUser: 'SU/member/mas/change/masusers/',
    },
    advertising: {
      sources: 'pub/vocabadvertisingsource/list',
    },
  },
  root: '/',
  sp: {
    referralProgram: '/referral-program',
    community: '/community',
    communityBlog: '/community/blog',
    communityBlogPost: '/community/blogpost',
    communityFaq: '/community/faq',
    marketPlace: '/marketPlace',
    appliedGigs: '/appliedGigs',
    gigsMenu: {
      gigs: '/mnuGigs',
      gigCompliance: gigCompliance,
      myGigs: myGigs,
    },
    schedulesMenu: {
      schedules: '/mnuSchedules',
      mySchedule: myScheduleBasePath,
      myAvialability: myAvailabilityBasePath,
      timeOff: timeOffBasePath,
    },
    communicationsMenu: {
      communications: '/mnuCommunications',
      mail: '/mail',
      chat: '/chat',
      serviceRequest: '/serviceRequest',
      remoteSupport: '/remoteSupport',
    },
    learn: '/learn',
    scheduling: {
      dashboard: '/dashboard',
      user: {
        profile: {
          index: `${userBasePath}/profile`,
          identification: `${userBasePath}/profile?tab=identification`,
          credentials: `${userBasePath}/profile?tab=credentials`,
          shippingAddress: `${userBasePath}/profile?tab=shippingAddress`,
          workHistory: `${userBasePath}/profile?tab=workHistory`,
          notify: `${userBasePath}/profile?tab=notify`,
          changePassword: `${userBasePath}/profile?tab=changePassword`,
          photo: `${userBasePath}/profile?tab=photo`,
          computerTest: `${userBasePath}/profile?tab=computerTest`,
          internetTest: `${userBasePath}/profile?tab=internetTest`,
          skills: `${userBasePath}/profile?tab=skills`,
          esign: `${userBasePath}/profile?tab=esign`,
        },
      },
      mySchedule: {
        index: myScheduleBasePath,
      },
      myAvailability: {
        index: myAvailabilityBasePath,
      },
      timeOff: {
        index: timeOffBasePath,
      },
      contract: {
        index: gigCompliance,
      },
      myGigs: {
        index: myGigs,
      },
      resources: {
        index: resourcesBasePath,
        client: `${resourcesBasePath}/:client`,
        category: `${resourcesBasePath}/:client/:resourceType`,
        database: `${resourcesBasePath}/:client/database/:dbId`,
        folder: `${resourcesBasePath}/:client/:resourceType/folder/:folderId`,
        view: `${resourcesBasePath}/:client/database/:dbId/view/:viewId`,
        dbWizard: `${resourcesBasePath}/:client/db-wizard`,
        preview: `${resourcesBasePath}-preview/:client/:resourceType/:id`,
        previewDatabaseItem: `${resourcesBasePath}-preview/:client/database/:dbId/view/:viewId/item/:id`,
      },
    },
    onboarding: {
      jobdescription: '/job-description',
      gigs: '/gigs',
      liveGigs: '/gigs?tab=Live',
      comingSoongGigs: '/gigs?tab=ComingSoon',
      appliedGigs: '/applied-gigs',
      courses: '/courses',
      classRegisterComplete: '/registration-complete/gig',
      resumeBuilder: '/resume-builder',
      jobs: '/jobs',
      applicationWizardStage2: {
        InternetTest: '/resume-builder?step=internet-test',
        ComputerTest: '/resume-builder?step=hardware-test',
        Equipment: '/resume-builder?step=equipment',
        Tax: '/resume-builder?step=tax',
        BgCheck: '/resume-builder?step=background-check',
      },
    },
    expiredLink: '/invalid-link',
  },
  auth: {
    logout: '/logout',
    login: '/login',
    resetPassword: '/reset-password',
    resetPasswordExpired: '/reset-password-expired',
    newPassword: {
      index: '/new-password',
      token: '/new-password/:resetToken',
    },
    postAuthRedirect: '/postAuthRedirect',
    gigApply: '/gig-apply',
    markAttendance: '/mark-attendance',
    speedTest: '/speedtest',
    terms: '/terms',
    privacy: '/privacy',
    community: '/community',
    stageTwo: '/stage-two',
  },
  resumeBuilderWizard: {
    educationOptions: '/pub/vocabeducationlevel/g/list',
    callCenterExperienceOptions: '/pub/vocabcallcenterexperience/g/list',
    languageOptions: '/pub/vocablanguage/g/list',
    proficiencyAreaOptions: '/pub/vocablanguageproficiencyarea/g/list',
    proficiencyOptions: '/pub/vocablanguageproficiency/g/list',
    internetTestList: '/member/profile/speedtest/list',
    applicationInternetTest: 'member/application/{applicationId}/speedtest/detail',
    internetTestCreate: '/technical/speedtest/create',
    testStatus: 'member/gigs/applied/status/list',
    internetTestDetails: '/member/profile/speedtest/detail',
    getProfilePicture: '/member/profilepicture/g/list/user',
    setLanguageProficiencies: '/member/userlanguage/create',
    getMemberSkills: '/member/skills/user?d=true',
    setMemberSkills: '/member/education/g/save',
  },
  client: {
    dashboard: {
      index: '/su-dashboard',
    },
    contracts: {
      index: '/contracts',
    },
    scheduling: {
      index: '/scheduling',
    },
    resources: {
      index: '/resources',
    },
    learn: {
      index: '/su-learn',
    },
    classId: {
      index: '/learn/:classId',
    },
    interviews: {
      index: '/interviews',
    },
    campaignsNew: {
      index: '/campaigns/:campaignId',
      applicants: '?tab=applicants',
      classes: '?tab=classes',
      upcomingInterviews: '?tab=upcoming-interviews',
      scheduleInterviews: '?tab=schedule-interviews',
      interviewScore: '?tab=interview-score',
      myEarnings: '?tab=my-earnings',
    },
    campaigns: {
      index: '/campaigns',
      interviewScore: '/interview-score',
      getCampaignApplicantCount: `SU${memberBasePath}/campaign/application/count`,
      getCampaignApplicantList: `SU${memberBasePath}/campaign/application/list`,
      getCampaignApplicationEndReasonList: `pub/vocabapplicationendreason/g/list`,
      declineApplication: `member/application/endapplication`,
      getApplicationLocktypesList: `member/application/locktypes`,
    },
    campaignId: {
      index: '/campaignsNew/:campaignId?tab=applicants',
    },
    communications: {
      notify: '/su-notify',
      chatLog: '/chat-log?reportId=8100',
    },
    reports: {
      index: '/reports',
      chatLog: '/chat-log',
    },
    community: {
      index: '/community',
    },
    onboardingMenu: {
      onboarding: '/mnuOnboarding',
      campaigns: '/campaigns',
      learn: '/su-learn',
    },
  },
  admin: {
    newgig: '/admin/newgig/:clientId',
    gig: {
      list: '/admin/gig',
      form: '/admin/gig/:clientId/:id',
      preview: '/admin/gig/',
    },
    campaign: {
      form: '/admin/gig/:clientId/:gigId/:campaignId',
    },
    course: {
      list: '/admin/course-builder',
      form: '/admin/course-builder/:clientId/:courseId',
      // form: (clientId: number, courseId: number) => `/admin/course-builder/${clientId}/${courseId}`,
    },
    class: {
      list: '/admin/class-builder',
      create: '/admin/class-builder/create',
      edit: '/admin/class-builder/edit',
    },
    permission: {
      index: '/admin/permissions',
    },
    agents: {
      index: '/mnuadmin/admin',
      serviceProviders: '/admin/service-providers',
      esignDocuments: '/admin/esigndocuments',
      fraudReviewGroups: '/admin/fraud-review-groups',
    },
    refer: {
      index: '/mnurefer/refer',
      payRates: '/refer/pay-rates',
      featuredGigs: '/refer/featured-gigs',
    },
    community: {
      index: '/admin/community',
    },
  },
  su: {
    contracts: 'SU/{userId}/client/{clientId}/contract/docs',
  },
} as const;

export default routes;

export const authRoutes = `(${getAllValues(routes.auth).join('|')})`;

const deepMapToFlatArray = (object: Record<string, string | Record<string, any>>): string[] =>
  Object.values(object).flatMap(item => {
    if (typeof item === 'object') return deepMapToFlatArray(item);
    return item;
  });

export const onboardingPaths = deepMapToFlatArray(routes.sp.onboarding);
export const schedulingPaths = deepMapToFlatArray(routes.sp.scheduling);
